export type UtmParams = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
};

export const addUtmParams = (url: string, utmParams: UtmParams) => {
  const urlObj = new URL(url);

  Object.entries(utmParams).forEach(([key, value]) => {
    const paramExists = urlObj.searchParams.has(key);
    if (value && !paramExists) {
      urlObj.searchParams.set(key, value);
    }
  });

  return urlObj.toString();
};
